module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header"
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'feed'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menu_open = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/logo_small.svg"),
      "alt": "The Warmup"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger",
    on: {
      "click": function($event) {
        _vm.menu_open = !_vm.menu_open
      }
    }
  }, [_vm._m(0)])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-end navbar-menu",
    class: {
      'is-active': _vm.menu_open
    }
  }, [_c('router-link', {
    staticClass: "navbar-item",
    class: {
      'is-active': _vm.$route.name == 'feed'
    },
    attrs: {
      "to": {
        name: 'feed'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menu_open = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('nav.home')) + "\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'players'
      },
      "active-class": "is-active"
    },
    nativeOn: {
      "click": function($event) {
        _vm.menu_open = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('nav.players')) + "\n      ")]), _vm._v(" "), _c('navbar-item-notifications', {
    nativeOn: {
      "click": function($event) {
        _vm.menu_open = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "navbar-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'player',
        params: {
          id: _vm.user.player.slug
        }
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menu_open = false
      }
    }
  }, [_c('player-avatar', {
    staticClass: "is-avatar",
    attrs: {
      "player": _vm.user.player,
      "size": "42"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-item"
  }, [_vm._m(1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "is-toggle navbar-item"
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-warning is-small",
    on: {
      "click": function($event) {
        _vm.throwHit()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('buttons.throw_hit')) + "\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b373f21","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrivateHeader.vue
// module id = 347
// module chunks = 9